import { SpaceProp, AlignItems, JustifyContent } from './Box.types'
import { SPACE } from '../GlobalStyles/constants'
import { css } from '@emotion/react'

export const resolveNegativeMarginLeft = (space: SpaceProp) => {
  return `-${SPACE[space]}`
}

export const resolveNegativeMarginTop = (space: SpaceProp) => {
  let adjustedSpace = parseInt(SPACE[space].replace(/px/, '')) + 1 + 'px'

  if (space === 'none') adjustedSpace = '0'

  const beforeStyle = css`
    display: block;
    content: '';
    margin-top: -${adjustedSpace};
  `
  return beforeStyle
}

export const resolveToPxIfUnitless = (value: string | number) =>
  typeof value === 'string' && /[0-9]$/.test(value) ? `${value}px` : value

export const resolveFlexAlign = (align: AlignItems) => {
  const alignMap = {
    start: 'flex-start',
    left: 'flex-start',
    top: 'flex-start',
    center: 'center',
    stretch: 'stretch',
    baseline: 'baseline',
    end: 'flex-end',
    right: 'flex-end',
    bottom: 'flex-end'
  }
  return alignMap[align]
}

export const resolveFlexJustify = (justify: JustifyContent) => {
  const justifyMap = {
    start: 'flex-start',
    left: 'flex-start',
    top: 'flex-start',
    center: 'center',
    end: 'flex-end',
    right: 'flex-end',
    bottom: 'flex-end',
    between: 'space-between',
    around: 'space-around',
    evenly: 'space-evenly'
  }
  return justifyMap[justify]
}
